module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper"
  }, [_vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-footer"
  }, _vm._l((_vm.servers), function(server) {
    return _c('iframe', {
      attrs: {
        "src": '/static/chats/chat-main.html?ip=' + server.ip + ':' + server.gamePort + '&nickname=' + _vm.safeName + '&server=' + encodeURIComponent(server.name)
      }
    })
  }))])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content-header"
  }, [_c('h1', [_vm._v("\n      Chats\n      "), _c('small', [_vm._v("All chats in one page")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7e85ccad!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/chats/Index.vue
// module id = 318
// module chunks = 2